export default __webpack_public_path__ + "static/media/CHEVROLET.a396a90e.png";